import styled, { keyframes, css } from "styled-components";

interface TabProps {
  $isFirst?: boolean;
  $isLast?: boolean;
  $isActive?: boolean;
  $rounded?: boolean;
}

export const SubHeaderContainer = styled.div`
  background-color: #fff;
  padding: 1.3rem 4.1rem;
  display: flex;
  justify-content: space-between;
  border-radius: .8rem;
  position: relative;
  z-index: 1;
`

export const SectionName = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  width: fit-content;
  padding-right: 1rem;
  margin-right: 1rem;
  border-right: 1px solid #EBEBEB;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`

export const TabsDiv = styled.div`
  font-family: 'Inter', sans-serif;
  display: flex;
`

export const Tab = styled.div<TabProps>`
  border: 2px solid #ebebeb;
  padding: 10px 24px 10px 16px;
  color: ${props => props.$isActive ? '#0090D3' : '#696969'};
  font-weight: ${props => props.$isActive ? 700 : 400};
  user-select: none;
  display: flex;
  align-items: center;
  font-size: .8rem;
  cursor: pointer;
  background-color: ${props => props.$isActive ? '#E6F4FB' : 'transparent'};
  border-color: ${props => props.$isActive ? '#0090D3' : '#ebebeb'};
  border-radius: ${props => {
    if (props.$rounded) return '0 2rem 2rem 0';
    if (props.$isFirst) return '2rem 0 0 2rem';
    if (props.$isLast) return '0 2rem 2rem 0';
    return '0';
  }};
  margin-left: ${props => props.$isFirst ? '0' : '-2px'};
  position: relative;
  z-index: ${props => props.$isActive ? '1' : '0'};

  img {
    filter: ${props => props.$isActive ? 'grayscale(0)' : 'grayscale(1)'};
    height: .8rem;
    margin-right: 0.4rem;
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  position: relative;
  z-index: 5;
`

export const RefreshIconContainer = styled.div`
  cursor: pointer;
  margin-right: 10px;
  color: #0090D3;
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: rotate(90deg);
  }

  &:active {
    transform: rotate(180deg);
  }
`;

export const OptionsButton = styled.div`
  border: 1px solid #0090D3;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  color: #0090D3;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f8ff; 
  }
`;

export const ConfigButton = styled(OptionsButton)``;

export const ButtonCreate = styled.div`
  font-weight: bold;
  user-select: none;
  display: flex;
  gap: 0.4rem;
  height: 100%;
  align-items: center;
  font-size: .8rem;
  padding: 0 1.5rem;
  color: #fff;
  cursor: pointer;
  background-color: #0090D3;
  border-radius: 2rem;
  position: relative;
  z-index: 10;
  pointer-events: auto;
  img{
    height: .8rem;
    margin-right: 0.4rem;
  }
`

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const RefreshIcon = styled.img<{ $spinning?: boolean }>`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  ${({ $spinning }) => $spinning ? css`animation: ${spin} 1s linear infinite;` : ''}
`

export const FilterWrapper = styled.div`
    position: relative;
`

export const FilterTypesDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CompanyTypes = styled.div`
  font-size: .8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.6px solid #B1B1B1;
  border-radius: .5rem;
  color: #B1B1B1;
  user-select: none;
  cursor: pointer;
  padding: .4rem .8rem;
  background-color: transparent;
  transition: all 0.12s ease;

  &:hover {
    border-color: #0090D3;
    color: #0090D3;
  }

  &.actived {
    color: #ffffff;
    border-color: #0090D3;
    font-weight: 600;
    background-color: #0090D3;
    box-shadow: 0 0 0 4px rgba(0,144,211,0.06);
  }
`